/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	distance: null,
	userZip: ''
};

export const distanceSlice = createSlice({
	name: 'distance',
	initialState,
	reducers: {
		setDistance(state, action) {
			return {
				...state,
				distance: action.payload.distance,
				userZip: action.payload.userZip
			};
		}
	}
});

export const { setDistance } = distanceSlice.actions;

export default distanceSlice.reducer;
